module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/008-estonia-f3eff2a3530dcf4411ba821db53cec7d.svg";